jQuery(document).ready(function($) {
    'use strict';

    const $post_form = $('#post_create');
    const $post_submit = $('.post_submit');
    const $loader = $('.flyout-loader');
    let elapsed_time = 0;
    var countdownInterval;

    $(document).on('click', '#quiz-submit', function(e) {
        e.preventDefault();

        let is_valid = validate_form();
        if (!is_valid) {
            return;
        }

        Swal.fire({
            title: 'Är du redo för att se resultatet?',
            text: 'Ange din e-postadress',
            icon: 'info',
            input: 'email',
            inputPlaceholder: 'Din e-postadress',
            inputValidator: (value) => {
                return new Promise((resolve) => {
                    if (!value) {
                        resolve('Du måste ange en e-postadress!');
                    } else if (!validateEmail(value)) {
                        resolve('Ange en giltig e-postadress!');
                    } else {
                        resolve();
                    }
                });
            },
            showCancelButton: true,
            confirmButtonColor: 'rgb(160 195 113 / var(--tw-bg-opacity))',
            cancelButtonColor: 'rgb(225 227 219 / var(--tw-bg-opacity))',
            confirmButtonText: 'Skicka',
            cancelButtonText: 'Avbryt',
        }).then(function(result) {
            if (result.isConfirmed && result.value) {
                let email = result.value;
                let fd = new FormData();

                fd.append('email', email);

                var questions = document.querySelectorAll(
                    '#quiz-container > form > div[data-id]');
                var answered_questions = [];

                questions.forEach(function(question) {
                    var radio_buttons = question.querySelectorAll(
                        'input[type="radio"]');
                    var question_number = question.getAttribute('data-id');

                    var checked = Array.from(radio_buttons)
                        .some(function(radio_button) {
                            if (radio_button.checked) {
                                answered_questions.push({
                                    questionId: radio_button.name,
                                    answer: radio_button.value,
                                });
                                return true;
                            }
                            return false;
                        });
                });

                fd.append('post_nonce', $('#post_nonce').val());
                fd.append('elapsed_time', elapsed_time);
                fd.append(
                    'answered_questions',
                    JSON.stringify(answered_questions),
                );
                fd.append('action', 'quiz_test_create');

                $.ajax({
                    type: 'POST',
                    url: '/wp-admin/admin-ajax.php',
                    data: fd,
                    contentType: false,
                    processData: false,
                    beforeSend: function(data) {
                        stopCountdown();

                        $post_form.hide();
                        $post_submit.prop('disabled', true);

                        $loader.css('display', 'flex');
                        $loader.find('strong')
                            .text(
                                'Kontrollerar test och skickar resutat till din e-post...');
                    },
                    success: function(response) {

                        $loader.find('.loading-symbol')
                            .removeClass('loading')
                            .addClass('icon-check');

                        $loader.find('strong')
                            .text(
                                'Resultatet är skickat till din e-post.');
                    },
                    error: function(xhr, textStatus, error) {
                        Swal.fire({
                            title: 'Ett fel uppstod, var god försök igen!',
                            text: 'Om felet kvarstår kontakta oss på jrf@jagarnasriksforbund.se.',
                            icon: 'error',
                        });

                        $post_form.show();
                        $post_submit.prop('disabled', false);
                    },
                });
            }
        });
    });

    function validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    }

    function validate_form() {
        var questions = document.querySelectorAll(
            '#quiz-container > form > div[data-id]');
        var isValid = true;
        var unanswered_questions = [];

        questions.forEach(function(question) {
            var radio_buttons = question.querySelectorAll('input[type="radio"]');
            var question_number = question.getAttribute('data-id');

            var checked = Array.from(radio_buttons)
                .some(function(radio_button) {
                    return radio_button.checked;
                });

            if (!checked) {
                isValid = false;
                unanswered_questions.push('Fråga ' + question_number);
            }
        });

        if (!isValid) {
            var message = unanswered_questions.join('<br>');

            Swal.fire({
                title: 'Följande frågor är inte besvarade',
                html: '<center>' + message + '</center>',
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: 'rgb(160 195 113 / var(--tw-bg-opacity))',
                confirmButtonText: 'Stäng',
            }).then(function(result) {
                if (result.isConfirmed === true) {

                }
            });
        }
        return isValid;
    }

    function startCountdown() {
        var countdown = 3599; // 1 hour in seconds
        var countdownElement = document.getElementById('countdown');

        countdownInterval = setInterval(function() {
            elapsed_time++;

            var hours = Math.floor(countdown / 3600);
            var minutes = Math.floor((countdown % 3600) / 60);
            var seconds = countdown % 60;

            countdownElement.innerHTML =
                minutes.toString().padStart(2, '0') +
                'min ' +
                seconds.toString().padStart(2, '0') + 'sek';

            if (countdown <= 300) {
                countdownElement.classList.add('text-red-600');
            }

            countdown--;

            if (countdown < 0) {
                clearInterval(countdownInterval);
                countdownElement.innerHTML = 'Tiden är slut';
                $post_submit.prop('disabled', true);
                $post_submit.hide();

            }
        }, 1000);
    }

    function stopCountdown() {
        clearInterval(countdownInterval);
    }

    startCountdown();

    function countAnsweredQuestions() {
        var answeredCount = 0;
        var radioInputs = document.querySelectorAll('input[type="radio"]');

        radioInputs.forEach(function(input) {
            if (input.checked) {
                answeredCount++;
            }
        });

        return answeredCount;
    }

    function updateAnsweredQuestionsCount() {
        var countDiv = document.getElementById('countanswers');
        countDiv.innerHTML = countAnsweredQuestions();
    }

    var radioInputs = document.querySelectorAll('input[type="radio"]');

    radioInputs.forEach(function(input) {
        input.addEventListener('click', function() {
            updateAnsweredQuestionsCount();
        });
    });
});